import { RealtorState } from "@/store/realtorState";
import axios from "axios";
import { useCallback, useState } from "react";
import { useRecoilState } from "recoil";

export const useAxios = <IUpload, IDownload, IStored>(
  endpoint: string,
  prosessing: (i: IDownload) => IStored
) => {
  //global
  const [realtor] = useRecoilState(RealtorState);

  //local
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [stored, setStored] = useState<IStored | null>(null);

  // reset function
  const reset = useCallback(async () => {
    setStored(null);
  }, []);

  // api function
  const fetch = useCallback(
    async (
      input: IUpload,
      OnUpdeted?: (item: IStored) => void,
      OnError?: () => void
    ) => {
      const inputData = {
        token: realtor.token,
        ...input,
      };
      setError(false);
      setIsLoading(true);
      await axios
        .post(endpoint, inputData, { timeout: 10000 })
        .then((res) => {
          const output: IDownload = res.data;
          const item = prosessing(output);
          if (OnUpdeted) OnUpdeted(item);
          setStored(item);
        })
        .catch(() => {
          if (OnError) OnError();
          setStored(null);
          setError(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    []
  );

  return { isLoading, result: stored, fetch, error, reset };
};
